import { render } from "./ReassignShipmentNotReady.vue?vue&type=template&id=002cc1e1&scoped=true"
import script from "./ReassignShipmentNotReady.vue?vue&type=script&lang=js"
export * from "./ReassignShipmentNotReady.vue?vue&type=script&lang=js"

import "./ReassignShipmentNotReady.vue?vue&type=style&index=0&id=002cc1e1&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002cc1e1"]])

export default __exports__